import { Modal } from "antd";
import React, { useEffect, useRef } from "react";
import WebUtils from "../../utils/WebUtils";
import { updateConversationHistoryApi } from "../../../api";
import Icon from "../../../assets/Icon";
import ReactTypingEffect from "react-typing-effect";

function TranscriptionClosedRejoinModal({
  transcriptionClosedRejoinModal,
  interviewData,
  videoBlobQueueRef,
  screenShareBlobQueueRef,
  timeRemainingRef,
  chatMessagesRef,
  stopRecording,
}) {
  const elapsedSecondsRef = useRef(0);
  const updateApiFlag = useRef(false);
  const endIntervalRef = useRef(null);

  const endInterviewFunc = () => {
    // setLoading(true);
    elapsedSecondsRef.current += 1;
    // console.log(
    //   updateApiFlag.current,
    //   anomalyApiFlag.current,
    //   elapsedSecondsRef.current
    // );
    if (
      elapsedSecondsRef.current >= 14 &&
      videoBlobQueueRef.current.length === 0 &&
      screenShareBlobQueueRef.current.length === 0 &&
      updateApiFlag.current
    ) {
      // setLoading(false);
      clearInterval(endIntervalRef.current);
      window.location.href = `/preview?interviewId=${interviewData?.interviewId}`;
      return;
    }
  };

  const updateConverstionHistory = () => {
    const url = updateConversationHistoryApi;

    const requestBody = {
      interviewId: interviewData?.interviewId,
      interviewRemainingTime: timeRemainingRef.current,
      conversation: chatMessagesRef.current,
    };

    WebUtils.httpOperations(url, requestBody, "POST")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        updateApiFlag.current = true;
      });
  };

  useEffect(() => {
    updateConverstionHistory();
    setTimeout(() => {
      stopRecording();
      endIntervalRef.current = setInterval(endInterviewFunc, 500);
    }, 1000);

    return () => {
      clearInterval(endIntervalRef.current);
    };
  }, []);
  return (
    <Modal
      className="rejoin-modal"
      open={transcriptionClosedRejoinModal}
      // onCancel={() => {
      //   updateConverstionHistory();
      //   endIntervalRef.current = setInterval(endInterviewFunc, 500);
      // }}
      centered
      footer={null}
      closeIcon={null}
      width={455}
    >
      <div className="">
        <Icon type="warning-icon" width="45" height="45" />
      </div>
      <div className="mt-[.55rem] font-semibold text-[1.05rem] text-[#101828]">
        Network Interruption
      </div>
      <p className="mt-[.55rem] text-[0.88rem] text-[#475467] leading-[1.38rem]">
        There was an issue with the network and the transcription got closed.
        Redirecting you to rejoin the interview.
      </p>
      <div className="mt-[.55rem] mb-[.35rem] text-[.88rem] text-[#206DC5] font-medium flex gap-1">
        Please wait,
        <ReactTypingEffect
          text={["while we are redirecting you to rejoin..."]}
          speed={50} // Typing speed
          eraseSpeed={30} // Erase speed
          eraseDelay={1000} // Delay before erasing
          typingDelay={500} // Delay before typing starts
          loop={true} // Infinite loop
        />
      </div>
    </Modal>
  );
}

export default TranscriptionClosedRejoinModal;
